import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import { WelcomeMessagesProviderInterface } from '@central-products/interface-welcome-messages-campaign-provider';
import { welcomeMessagesQuery, marketingPreferencesMutation } from './graphql/queries';
export var WelcomeMessagesProvider = /*#__PURE__*/function (_WelcomeMessagesProvi) {
  _inherits(WelcomeMessagesProvider, _WelcomeMessagesProvi);

  var _super = _createSuper(WelcomeMessagesProvider);

  function WelcomeMessagesProvider(_config, dependencies) {
    var _this;

    _classCallCheck(this, WelcomeMessagesProvider);

    _this = _super.call(this);
    _this.dependencies = dependencies;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(WelcomeMessagesProvider, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var campaignName, assetPath, variables, _response$data, query, response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                campaignName = _ref.campaignName, assetPath = _ref.assetPath, variables = _ref.variables;
                _context.prev = 1;
                query = welcomeMessagesQuery({
                  campaignName: campaignName,
                  assetPath: assetPath,
                  variables: variables
                }); // @ts-ignore

                _context.next = 5;
                return this.dependencies['data-access-service'].query(query);

              case 5:
                response = _context.sent;

                if (!response.errors) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", {
                  error: response.errors[0]
                });

              case 8:
                return _context.abrupt("return", {
                  campaign: (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.campaign
                });

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", {
                  error: _context.t0
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "updateMarketingPreferences",
    value: function updateMarketingPreferences(payload) {
      var mutation = marketingPreferencesMutation(payload); // @ts-ignore

      return this.dependencies['data-access-service'].mutate(mutation);
    }
  }]);

  return WelcomeMessagesProvider;
}(WelcomeMessagesProviderInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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